import React from 'react';
import { Button, Modal } from 'react-bootstrap';

// Models
import Group from '../Models/Group'

export interface DeleteGroupModalProps {
    show:boolean;
    group:Group;
    didPressDone: () => void;
    didPressDelete: () => void;
}

export type DeleteGroupModalState = { }

export default class DeleteGroupModal extends React.Component<DeleteGroupModalProps, DeleteGroupModalState> {
    render(){
        return (
            <Modal show={this.props.show} onHide={this.props.didPressDone}>
                <Modal.Header>
                    <Modal.Title>Delete Group</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you would like to delete {this.props.group.name}?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={this.props.didPressDelete}>Delete</Button>   
                    <Button variant="secondary" onClick={this.props.didPressDone}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}